import config from "../../config/index.json"
// Função para listar todos os pedidos
export async function listOrders(user) {
    let url = `${config.urlServer}/pdv/orders/list`;
    let headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      uid: user.uid,
      tokenfirebase: user?.token_firebase,
      tokenbackend: user?.token_backend,
      email: user.email,
      restaurantid: user.restaurant_id,
      userpdvid: user.user_pdv_id
    };
  
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });
      console.log('response')

  
      if (response.status === 200) {
        const data = await response.json();
      console.log(data)

        return data;
      } else {
        const errorData = await response.json();
        throw new Error(`Failed to list orders: ${errorData.msg}`);
      }
    } catch (error) {
      console.error("Error while listing orders:", error);
      throw error;
    }
  }
  